import { Component, OnInit, Injector, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DataTable } from 'primeng/components/datatable/datatable';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { Paginator } from 'primeng/components/paginator/paginator';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { CredentialsServiceProxy, EventsServiceProxy, UserServiceProxy, EnterpriseServiceProxy } from '@shared/service-proxies/service-proxies';
import { CreateOrEditCredentialModalComponent } from '@app/event/credentials/modal/create-or-edit-credential-modal.component';

@Component({
  templateUrl: './credentials.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()]
})
export class CredentialsComponent extends AppComponentBase {

  @ViewChild('createOrEditCredentialModal') createOrEditCredentialModal: CreateOrEditCredentialModalComponent;
  @ViewChild('dataTable') dataTable: DataTable;
  @ViewChild('paginator') paginator: Paginator;

  //Filters
  filterText = '';
  filterUser = undefined;
  filterEvent = undefined;
  filterExhibitor = undefined;
  advancedFiltersAreShown = false;

  users = [];
  events = [];
  enterprises = [];

  downloadingExcel = false;

  constructor(
    injector: Injector,
    private _userService: UserServiceProxy,
    private _eventsService: EventsServiceProxy,
    private _fileDownloadService: FileDownloadService,
    private _credentialService: CredentialsServiceProxy,
    private _enterpriseService: EnterpriseServiceProxy
  ) {
    super(injector);
  }

  getCredentials(event?: LazyLoadEvent) {
    if (this.primengDatatableHelper.shouldResetPaging(event)) {
      this.paginator.changePage(0);

      return;
    }

    this.primengDatatableHelper.showLoadingIndicator();

    this._credentialService.getAll(
      this.filterText,
      this.filterEvent ? this.filterEvent.id : undefined,
      this.filterUser ? this.filterUser.id : undefined,
      this.filterExhibitor ? this.filterExhibitor.id: undefined,
      undefined,
      this.primengDatatableHelper.getSorting(this.dataTable),
      this.primengDatatableHelper.getSkipCount(this.paginator, event),
      this.primengDatatableHelper.getMaxResultCount(this.paginator, event)
    )
    .finally(() => {
      this.primengDatatableHelper.hideLoadingIndicator();
    })
    .subscribe(result => {
      this.primengDatatableHelper.totalRecordsCount = result.totalCount;
      this.primengDatatableHelper.records = result.items;
    });
  }

  reloadPage(): void {
    this.paginator.changePage(this.paginator.getPage());
  }

  clear(): void {
    this.filterText = '';
    this.filterUser = undefined;
    this.filterEvent = undefined;
    this.filterExhibitor = undefined;
  }

  exportToExcel(): void {

    this.downloadingExcel = true;

    this._credentialService.getCredentialsToExcel(
        this.filterText,
        this.filterEvent ? this.filterEvent.id : undefined,
        this.filterUser ? this.filterUser.id : undefined,
        this.filterExhibitor ? this.filterExhibitor.id: undefined,
        undefined,
      )
      .finally(() => {
        this.downloadingExcel = false;
      })
      .subscribe(result => {
          this._fileDownloadService.downloadTempFile(result);
      });
  }

  createCredential(): void {
    this.createOrEditCredentialModal.show();
  }

  // Get Users
  filterUsers(event): void {
    this._userService.getUsersForSelect(
        event.query,
        undefined,
        20,
        0
      ).subscribe(result => {
      this.users = result.items;
    });
  }

  // Get Events
  filterEvents(event): void {
      this._eventsService.getEventsForSelect(event.query, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
          this.events = result.items;
      });
  }

  // Get Institutions
  filterEnterprises(event): void {
      this._enterpriseService.getEnterpriseForSelectAsync(
        event.query,
        undefined,
        undefined,
      ).subscribe(result => {
          this.enterprises = result.items;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/event/credentials/credentials.component.ts